import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Badge, Col, Modal, Row, Spinner} from "react-bootstrap";
import Button from "react-bootstrap/esm/Button";
import {MdOutlineCancel} from "react-icons/md";
import {TbReload} from "react-icons/tb";
import Alert from "react-bootstrap/Alert";
import {getGreekCurrencyFormat, quickClone} from "../../../../../_helpers/commonFunctions";
import EditableTable from "../../../../primer/Editable-Table";
import axios from "axios";
import useInstallationOptions from "../../../../../hooks/useInstallationOptions";
import Dropdown from "../../../../primer/Dropdown";
import {preNumberGreek} from "../../../../../_data/settings/advanced-types-search";
import {fetchPOS} from "../../../../../_apis/api";

const AIBatchSettlementModal = ({show, setShow, aiDoc, onSave, onReprocess, onDecline}) => {
    const dispatch = useDispatch();
    const aiSettings = useSelector((state) => state.AI.aiSettings);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const allDocumentTypes = useSelector((state) => state.SETTINGS.settings.advancedTypes);
    const posList = useSelector((state) => state.CASH_DATA.posList);
    const posOptions = posList.map((o) => ({value: o._id, label: o.name}));

    const [batchObject, setBatchObject] = useState(null);
    const [entitiesList, setEntitiesList] = useState([]);

    const [loadingSave, setLoadingSave] = useState(false);
    const [incrKey, setIncrKey] = useState(0);

    const installationOptions = useInstallationOptions(false);
    const documentTypeOptions = allDocumentTypes.filter((el) => el.section === "Client Payments")
        .map((o) => ({value: o._id, label: o.name}));

    useEffect(() => {
        if (show) {
            dispatch(fetchPOS({company: company.id}));
            setBatchObject({
                ...aiDoc.batchSettlement,
                installation: "0",
                documentType: aiSettings?.batchSettlementsDefaultCP || "",
                preNumber: aiSettings?.batchSettlementsDefaultCPPreNumber || "",
                documentTypeReturn: aiSettings?.batchSettlementsDefaultCPReturn || "",
                preNumberReturn: aiSettings?.batchSettlementsDefaultCPReturnPreNumber || "",
            });
            loadEntitiesList(null, setEntitiesList);
        } else {
            setBatchObject(null);
            setEntitiesList([]);
        }
    }, [show])

    useEffect(() => {
        setIncrKey(incrKey + 1);
    }, [batchObject?.transactions, entitiesList])

    const loadEntitiesList = (keyword, setData) => {
        if (!Array.isArray(setData)) setData = [setData];

        const reqData = { company: company.id }
        if (keyword) reqData.name = keyword;

        axios.get(`${process.env.REACT_APP_API_URL2}/accounting/get-subAccount-by-word`, {
            headers: {"Content-Type": "application/json"},
            params: {
                company: company.id,
                subAccountType: "client",
                keyword,
            },
        }).then((res) => {
            if (res.data && res.data.status === "200") {
                if (Array.isArray(setData)) {
                    for (const func of setData) {
                        if (res.data.data) func(res.data.data);
                        else func([]);
                    }
                }
            } else {
                for (const func of setData) func([]);
            }
        }).catch((e) => {
            console.log(e);
        })
    }

    const transactionsTableColumns = [
        {
            name: "Αρ.",
            field: "no",
            width: "40px",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Ημερομηνία Συναλλαγής",
            field: "dateString",
            editable: false,
            width: "15%",
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Αναγνωριστικά Συναλλαγής",
            field: "identifier",
            editable: true,
            width: "25%",
            inputType: {
                type: "custom-render",
                render: (rowData) => {
                    if (rowData.identifier) {
                        const split = rowData.identifier.split("|");
                        return (
                            <div>{split.map((identifier) => <Badge bg={"primary"} style={{fontSize: "13px", padding: "3px"}} className={"m-1"}>{identifier}</Badge>)}</div>
                        )
                    }
                    return <></>
                }
            }
        },
        {
            name: "Ποσό Συναλλαγής",
            field: "amount",
            editable: true,
            width: "15%",
            inputType: {
                type: "custom-render",
                render: (rowData) => <div className={"text-center"}>{getGreekCurrencyFormat(rowData.amount)}</div>
            }
        },
        {
            name: "Προμήθεια Συναλλαγής",
            field: "commission",
            editable: true,
            width: "15%",
            inputType: {
                type: "custom-render",
                render: (rowData) => <div className={"text-center"}>{getGreekCurrencyFormat(rowData.commission)}</div>
            }
        },
        {
            name: "Επιλεγμένος πελάτης",
            field: "clientName",
            editable: true,
            disabledCallback: (rowData) => rowData?.existent,
            width: "30%",
            inputType: {
                config: {
                    onChangeSearchCell: (_, keyword, setData) => loadEntitiesList(keyword, setData),
                    excludeColumns: [],
                    columns: [
                        { label: "Κωδικός Συστήματος", name: "systemCode" },
                        { label: "Όνομα", name: "name" },
                        { label: "Τηλέφωνο", name: "phone" },
                        { label: "E-Mail", name: "email" },
                        { label: "Α.Φ.Μ.", name: "vatNumber" },
                    ],
                    data: entitiesList,
                    deleteEnable: false,
                    searchTableEnable: false,
                    showTableOptionOnSelect: true,
                    placeholder: "Επιλέξτε πελάτη",
                },
                type: 'advanced-combobox',
            }
        },
    ]

    const onTableTransactionsUpdate = {
        insert: () => {},
        update: (data, id, rowIndex, e) => {
            const cloneData = quickClone(batchObject.transactions);
            if (data.clientName) {
                cloneData[rowIndex] = {
                    ...cloneData[rowIndex],
                    client: e.row._id,
                    clientName: e.row.name,
                }
            }
            setBatchObject({...batchObject, transactions: cloneData});
        },
        selected: () => {},
        delete: () => {}
    }

    const handleOnChange = (e, type, name) => {
        const cloneIt = quickClone(batchObject);
        if (type === "dd") {
            cloneIt[name] = e.value;
        }
        setBatchObject(cloneIt);
    }

    return (
        <React.Fragment>
            <Modal show={show} onHide={() => setShow(false)} backdrop={"static"} dialogClassName={"modal95PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>Καταχώρηση Πακέτου Καρτών</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {batchObject !== null && (
                        <React.Fragment>
                            <Alert variant={"secondary"} style={{fontSize: "16px"}}>
                                Το παρόν αρχείο έχει εντοπιστεί ότι αποτελεί πακέτο εκκαθάρισης συναλλαγών καρτών της επιχείρησης.
                                Παρακάτω φαίνεται αναλυτικός πίνακας ανά συναλλαγή, καθώς και ο εντοπισμένος πελάτης που αντιστοιχεί.
                                Κατά την αποθήκευση δημιουργούνται μόνο οι ανάλογες εισπράξεις / επιστροφές εισπράξεων.<br/><br/>
                                <strong>Πλήθος συναλλαγών:</strong> {batchObject.totalTransactions}<br/>
                                <strong>Συνολικό ποσό συναλλαγών:</strong> {getGreekCurrencyFormat(batchObject.totalAmount)}<br/>
                                <strong>Συνολικό ποσό προμηθειών:</strong> {getGreekCurrencyFormat(batchObject.totalCommission)}<br/>
                            </Alert>
                            <Row>
                                <Col md={3}>
                                    <Dropdown
                                        name={"installation"}
                                        label={"Εγκατάσταση POS"}
                                        key={Math.random()}
                                        required={true}
                                        options={installationOptions}
                                        defaultValue={installationOptions.find((el) => el.value === batchObject.installation)}
                                        onChange={(e) => handleOnChange(e, "dd", "installation")}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Dropdown
                                        name={"pos"}
                                        label={"Συσχετιζόμενο POS"}
                                        key={Math.random()}
                                        required={true}
                                        options={posOptions}
                                        defaultValue={posOptions.find((el) => el.value === batchObject.pos)}
                                        onChange={(e) => handleOnChange(e, "dd", "pos")}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Dropdown
                                        name={"documentType"}
                                        label={"Γενικό Παραστατικό"}
                                        key={Math.random()}
                                        required={true}
                                        options={documentTypeOptions}
                                        defaultValue={documentTypeOptions.find((el) => el.value === batchObject.documentType)}
                                        onChange={(e) => handleOnChange(e, "dd", "documentType")}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Dropdown
                                        name={"preNumber"}
                                        label={"Αρίθμηση"}
                                        key={Math.random()}
                                        required={true}
                                        options={preNumberGreek}
                                        defaultValue={preNumberGreek.find((el) => el.value === batchObject.preNumber)}
                                        onChange={(e) => handleOnChange(e, "dd", "preNumber")}
                                    />
                                </Col>
                            </Row>
                            {batchObject.transactions.some((el) => el.amount < 0) && (
                                <Row>
                                    <Col md={3}>
                                        <Dropdown
                                            name={"documentTypeReturn"}
                                            label={"Γενικό Παραστατικό Επιστροφών"}
                                            key={Math.random()}
                                            required={true}
                                            options={documentTypeOptions}
                                            defaultValue={documentTypeOptions.find((el) => el.value === batchObject.documentTypeReturn)}
                                            onChange={(e) => handleOnChange(e, "dd", "documentTypeReturn")}
                                        />
                                    </Col>
                                    <Col md={3}>
                                        <Dropdown
                                            name={"preNumberReturn"}
                                            label={"Αρίθμηση Επιστροφών"}
                                            key={Math.random()}
                                            required={true}
                                            options={preNumberGreek}
                                            defaultValue={preNumberGreek.find((el) => el.value === batchObject.preNumberReturn)}
                                            onChange={(e) => handleOnChange(e, "dd", "preNumberReturn")}
                                        />
                                    </Col>
                                </Row>
                            )}
                            <Row>
                                <Col md={12}>
                                    <EditableTable
                                        tableName={"AI Batch Settlement Transactions Table"}
                                        key={"AI Batch Settlement Transactions Table" + incrKey}
                                        allowActions={false}
                                        onUpdate={onTableTransactionsUpdate}
                                        allowInsertRow={false}
                                        columns={transactionsTableColumns}
                                        enableNewRowCheckbox={false}
                                        data={batchObject.transactions}
                                    />
                                </Col>
                            </Row>
                        </React.Fragment>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-danger" className={"mr-1"} onClick={() => onDecline(aiDoc)}>
                        <MdOutlineCancel size={16} /> Απόρριψη
                    </Button>
                    <Button variant="primary" className={"mr-1"} onClick={() => onReprocess(aiDoc)}>
                        <TbReload size={16} /> Επαναεπεξεργασία
                    </Button>
                    <Button variant="outline-primary" onClick={() => setShow(false)}>
                        Κλείσιμο
                    </Button>
                    <Button variant="primary" onClick={() => onSave(aiDoc, batchObject, setLoadingSave)} disabled={loadingSave}>
                        Αποθήκευση {loadingSave && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export default AIBatchSettlementModal;
